/**
 * iframe安全处理工具，用于处理大华视频播放器与第三方iframe共存的CSP问题
 */

/**
 * 检测页面上是否存在第三方iframe
 * @returns {boolean} 是否存在第三方iframe
 */
export function detectThirdPartyIframes() {
  const iframes = document.querySelectorAll('iframe');
  return iframes.length > 0;
}

/**
 * 为iframe添加安全属性，避免CSP冲突
 * @param {HTMLIFrameElement} iframe - 需要处理的iframe元素
 */
export function secureIframe(iframe) {
  if (!iframe) return;
  // 添加安全属性
  iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-forms allow-popups');
  iframe.setAttribute('class', iframe.getAttribute('class') + ' baidu-iframe');
  // 可选: 为已存在的iframe设置CSP
  try {
    if (iframe.contentWindow && iframe.contentWindow.document) {
      const meta = iframe.contentWindow.document.createElement('meta');
      meta.setAttribute('http-equiv', 'Content-Security-Policy');
      // 允许大华播放器的frame-ancestors
      meta.setAttribute('content', "frame-ancestors 'self' *;");
      iframe.contentWindow.document.head.appendChild(meta);
    }
  } catch (e) {
    console.warn('Cannot access iframe content: ', e);
  }
}

/**
 * 为所有页面iframe添加安全属性
 */
export function secureAllIframes() {
  const iframes = document.querySelectorAll('iframe');
  iframes.forEach(iframe => {
    secureIframe(iframe);
  });
}

/**
 * 监听新增iframe并自动添加安全属性
 */
export function watchForNewIframes() {
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.tagName === 'IFRAME') {
            secureIframe(node);
          } else if (node.querySelectorAll) {
            const iframes = node.querySelectorAll('iframe');
            iframes.forEach(iframe => secureIframe(iframe));
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  return observer; // 返回observer以便稍后可能需要断开
}

/**
 * 初始化iframe安全处理
 * - 处理已有iframe
 * - 监视新增iframe
 * @returns {MutationObserver} iframe观察器
 */
export function initIframeSafety() {
  // 处理已有iframe
  secureAllIframes();
  // 监视新iframe
  return watchForNewIframes();
}

export default {
  detectThirdPartyIframes,
  secureIframe,
  secureAllIframes,
  watchForNewIframes,
  initIframeSafety
}; 